module.exports = __webpack_public_path__ + "img/leadlovers.43b76130.svg";